import { generateAppEntity } from "@others/generateAppEntity.ts"

export const AppIndexedDBKeys = {
	LOGGED_USER: generateAppEntity("loggedUser"),
	APPLY_MEMBERSHIP_FORM_DATA: generateAppEntity("applyMembershipFormData"),
	SPACE_ALL_PLACES: generateAppEntity("spaceAllPlaces"),
	BOOKINGS: generateAppEntity("bookings"),
}
